import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCorner = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.97611 10.2866C4.19553 11.8712 5.35902 13.2351 7.00869 13.6294C7.80448 13.8196 8.60126 13.7567 9.31561 13.494L9.76618 14.9304L9.36592 15.0563C6.11813 16.0746 2.65997 14.267 1.6416 11.0192L3.97611 10.2866Z",
			fill: "#005500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.65046 9.44852C7.35292 9.22847 8.10098 9.61943 8.32135 10.3218L9.11635 12.8573C8.51339 13.0857 7.83802 13.1422 7.16367 12.981C5.75036 12.6432 4.76525 11.4515 4.62302 10.0838L6.65046 9.44852Z",
			fill: "#005500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3891 6.84648C11.8707 7.70775 9.35235 5.65567 6.83398 6.73936V1.1217C9.23404 0.0889214 11.634 1.90419 14.0341 1.33155C14.3497 1.25626 14.6669 1.44612 14.6669 1.70426V6.49707C14.6669 6.64541 14.5628 6.78707 14.3891 6.84648Z",
			fill: "#CC2929"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M14.6669 6.15075V6.49792C14.6669 6.64385 14.5641 6.78471 14.3908 6.84509C11.874 7.7105 9.3508 5.65266 6.83398 6.73945V1.10934C7.28346 0.918144 7.73285 0.822545 8.18225 0.797363C8.09243 1.46151 8.0603 2.88539 9.26091 4.18853C10.9366 6.00989 13.6781 6.16083 14.6669 6.15075Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.1353 11.6909C6.919 11.6909 6.74365 11.4751 6.74365 11.209V0.982418C6.74365 0.716254 6.919 0.500488 7.1353 0.500488C7.3516 0.500488 7.52694 0.716257 7.52694 0.982418V11.209C7.52695 11.4751 7.3516 11.6909 7.1353 11.6909Z",
			fill: "#D08867"
		})
	]
});
export default SvgCorner;
